$(document).ready(function()
{

    $( ".stay-on-page-dropdown-menu a" ).click(function(e) 
    {
        e.preventDefault();
        var filterValue = $(this).data("filter-value");
        var text = $(this).text();
        $('#filterDropdown').html(text);
        applyDropdownFilters(filterValue);
    });

    // remove empty items from dropdown menu
    // only needed if crossing across taxonomies
    function cleanseTheDropdownFilterTool()
    {
        var long_string = '';
        // first hide them all
        $('#listingsGroup .card').each(function(i, obj)
        {
            long_string = long_string + ' ' + $(this).data('category');
        });

        $('.stay-on-page-dropdown-menu .dropdown-item').each(function()
        {
            if (long_string.includes($(this).data('filter-value')))
            {
                //
            }
            else
            {
                $(this).remove();
            }
        });
      
    }


    function applyDropdownFilters(filterValue)
    {
        let active_ids = 0;
        let toggle_type = 'blog';

        if ($('#listingsGroup').hasClass('card-deck-new'))
        {
            toggle_type = 'card';
        }


        // first hide them all
        $('#listingsGroup .card').each(function(i, obj)
        {
            if (toggle_type == 'card')
            {
                $(this).parent().fadeOut(300);
            }
            else
            {
                $(this).fadeOut(300);
            }
        });

        setTimeout( 
            function() 
            { 
                showActiveCards(filterValue);
            }, 300 
        );

        function showActiveCards(filterValue)
        {
            // return those inside the current limit
            $('#listingsGroup .card').each(function(i, obj)
            {
                showItem = 0;

                if(!filterValue || (filterValue && $(this).data('category').includes(filterValue) ) )
                {
                    showItem++;
                }
                if(showItem > 0)
                {
                    active_ids++;
                    if (toggle_type == 'card')
                    {
                         $(this).parent().fadeIn(300); 
                    }
                    else
                    {
                         $(this).fadeIn(300); 
                    }

                }
            });
            //console.log(active_ids);
            $('#page-counter-results').text(active_ids + " item" + ( (active_ids != 1) ? "s" : ''  ));

            if (active_ids > 0)
            {
                $("#no-results").removeClass("active");                
            }
            else
            {
                $("#no-results").addClass("active");   
                //$("#listings-sort a").removeClass("active");
            }
        }

    }

    if ( $('#listingsGroup').length && $('.stay-on-page-dropdown-menu').length )
    {
        cleanseTheDropdownFilterTool();
    }

});